export const initialErrorState = {
  ingestionError: '',
  fileError: '',
  slideNumberError: '',
  groupNameError: '',
  noAvailableGroupsError: '',
};
export const ErrorActionType = {
  INGESTION_ERROR: 'Ingestion Error',
  FILE_ERROR: 'File Error',
  SLIDE_NUMBER_ERROR: 'Slide Number Error',
  GROUP_NAME_ERROR: 'Group Name Error',
  NO_AVAILABLE_GROUPS_ERROR: 'No Available Groups Error',
  CLEAR: 'Clear',
};
export const ErrorAction = {
  NoFilesInSharePointError: {
    type: ErrorActionType.FILE_ERROR,
    value: 'No PowerPoint files found.',
  },
  NoSlidesInPowerPointFileError: {
    type: ErrorActionType.SLIDE_NUMBER_ERROR,
    value: 'There are no slides for the selected PowerPoint file',
  },
  NoGroupsInPowerPointSlideError: {
    type: ErrorActionType.GROUP_NAME_ERROR,
    value: `No groups or items available from the selected slide. Please make sure you've selected the correct slide.`,
  },
  NoAvailableGroupsInPowerPointSlideError: {
    type: ErrorActionType.NO_AVAILABLE_GROUPS_ERROR,
    value: `No new groups or items are available to import from the selected slide. Please check the library if they've already been imported.`,
  },
  FailedRetrievingPowerPointSlides: {
    type: ErrorActionType.SLIDE_NUMBER_ERROR,
    value:
      'There was a problem retrieving slide information from the selected PowerPoint file',
  },
  IngestionError: {
    type: ErrorActionType.INGESTION_ERROR,
    value:
      'No groups or items available from the selected file. Please make sure your file has been created correctly and try re-uploading it to Sharepoint.',
  },
  Clear: {
    type: ErrorActionType.CLEAR,
    value: initialErrorState,
  },
};

export const initErrorState = ({
  ingestionError = '',
  fileError = '',
  slideNumberError = '',
  groupNameError = '',
  noAvailableGroupsError = '',
}) => {
  return {
    ingestionError,
    fileError,
    slideNumberError,
    groupNameError,
    noAvailableGroupsError,
  };
};

export const errorReducer = (state, action) => {
  switch (action.type) {
    case ErrorActionType.INGESTION_ERROR:
      return { ...state, ingestionError: action.value };
    case ErrorActionType.FILE_ERROR:
      return { ...state, fileError: action.value };
    case ErrorActionType.SLIDE_NUMBER_ERROR:
      return { ...state, slideNumberError: action.value };
    case ErrorActionType.GROUP_NAME_ERROR:
      return { ...state, groupNameError: action.value };
    case ErrorActionType.NO_AVAILABLE_GROUPS_ERROR:
      return { ...state, noAvailableGroupsError: action.value };
    case ErrorActionType.CLEAR:
      return action.value;
    default:
      return { ...state };
  }
};
